import React from 'react';
import ReactDOM from 'react-dom';
import { BrowserRouter as Router, Route } from 'react-router-dom';
import './index.css';
import App from './App';
import LegacyViewer from './containers/legacy';
import FormViewer from './containers/fillableform';
import ChoiceViewer from './containers/choicereview';
import FormReview from './containers/formreview';
import PageOrder from './containers/pageorder';
import AnnotationImport from './containers/annotationimport';
//import registerServiceWorker from './registerServiceWorker';
import { unregister } from './registerServiceWorker';
import {
  TermsOfUse,
  TermsOfUseArchive,
  TermsOfUsePerm
} from './containers/termsofuse';
import Login from './containers/signin';
import DocumentsTable from './containers/documenttable';
import Externalviewer from './containers/externalviewer';
import { AuthProvider } from './containers/externalauthentication/authprovider';
import { PrivateRoute } from './containers/externalauthentication/externalprivateroute';
import { IntegrationViewer } from './containers/integration';
import queryString from 'query-string';
import Expired from './containers/expired';

export const isModernApi = () => {
  const parsed = queryString.parse(window.location.search);
  if (parsed.newchive) {
    return true;
  }
  return false;
};

ReactDOM.render(
  <AuthProvider>
    <Router>
      <div>
        <Route path="/legacy/:client/:superid" component={LegacyViewer} />
        <Route path="/current/:superid" component={App} />
        <Route
          path="/choicereview/:client/:superid/:formid"
          component={ChoiceViewer}
        />
        <Route path="/formreview/:client/:formpath" component={FormReview} />
        <Route
          path="/choiceforms/:client/:superid/:currentStudent?"
          component={FormViewer}
        />

        <Route
          path="/cumulativefolder/:client/:superid/:tenant/:stage"
          component={IntegrationViewer}
        />
        <Route
          path="/integration/:client/:superid/:tenant/:stage"
          component={IntegrationViewer}
        />
        <Route path="/pageorder/:client/:superid" component={PageOrder} />
        <Route path="/importannotations/:client" component={AnnotationImport} />
        <Route path="/termsofuse" component={TermsOfUse} />
        <Route path="/termsofuseperm" component={TermsOfUsePerm} />
        <Route
          path="/termsofusearchive/:districtName"
          component={TermsOfUseArchive}
        />

        <PrivateRoute
          exact={true}
          path="/external"
          component={DocumentsTable}
        />
        <Route exact={true} path="/external/signin" component={Login} />
        <PrivateRoute
          path="/external/viewer/:superid"
          component={Externalviewer}
        />
        <Route path="/expired" component={Expired} />
      </div>
    </Router>
  </AuthProvider>,
  document.getElementById('root')
);
console.log('calling unregister');
unregister();
